import { createAction, props } from '@ngrx/store';

export const subscribeToNewsletter = createAction(
  '[Newsletter] subscribe',
  props<{ email: string }>()
);
